import classNames from "classnames/bind";
import styles from "./ProductAvailability.module.scss";

const cx = classNames.bind(styles);

export interface ProductAvailabilityProps {
  eligibleCount: number;
  ineligibleCount: number;
  fullWidth?: boolean;
}

const ProductAvailability = ({
  eligibleCount,
  ineligibleCount,
  fullWidth,
}: ProductAvailabilityProps) => {
  return (
    <div
      className={cx("wrapper", { fullWidth })}
      data-testid="productAvailabilityWrapper"
    >
      <div className={cx("item", "itemPrimary")}>
        {eligibleCount} products available
      </div>
      <div className={cx("item", "itemSecondary")}>
        {ineligibleCount} outside criteria
      </div>
    </div>
  );
};

export default ProductAvailability;
